import { render, staticRenderFns } from "./CompanyFounder.vue?vue&type=template&id=16de4eb2&scoped=true&"
import script from "./CompanyFounder.vue?vue&type=script&lang=js&"
export * from "./CompanyFounder.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFounder.vue?vue&type=style&index=0&id=16de4eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de4eb2",
  null
  
)

export default component.exports